
import { Vue } from "vue-class-component";

export default class User extends Vue {}
